// src/lang/zh-CN.js
export default {
    navbar: {
        home: "首页",
        productCenter: "产品中心",
        productAttachment: "附件",
        industryApplications: "行业应用",
        newsEvents: "新闻活动",
        serviceRepair: "服务维修",
        aboutUs: "关于我们",
        contactUs: "联系我们",
        shoppingMall: "商城",
        order: "订单",
        login: "登录"
    },
    footer: {
        innaChina: "INNA中国",
        address: "地址：辽宁省大连市金普新区光谷南路11号",
        fax: "传真：+86 411 88035448",
        phone: "电话：+86 411 88035458",
        email: "邮箱：http://info@innaspindle.com",
        copyright: "Copyright © 2025 INNA电主轴官网 辽ICP备19020774号-1",
        security: "辽公网安备21021702000669",
        miniProgram: "小程序",
        enterpriseWeChat: "企业微信"
    },
    mobileMenu: {
        productCenter: "产品中心",
        industryApplications: "行业应用",
        newsEvents: "新闻活动",
        serviceRepair: "服务维修",
        aboutUs: "关于我们",
        contactUs: "联系我们",
        shoppingMall: "商城"
    },
    langSwitch: {
        chinese: "中文",
        english: "English"
    },
    "转速": "转速",
    "扭矩": "扭矩",
    "功率": "功率",
    "Rotational speed": "转速",
    "Torque": "扭矩",
    "Power": "功率",
    chart: {
        torqueTitle: "扭矩曲线图",
        powerTitle: "功率曲线图",
        speedAxis: "转速 (rpm)",
        torqueAxis: "扭矩 (N·m)",
        powerAxis: "功率 (kW)",
        seriesPlaceholder: "产品",
        dataError: "数据异常",
        unknownCategory: "未知类别",
        selected: "已选中",
        unselected: "未选中",
        value: "数值",
        status: "状态"
    }

    ,home: {
        reasonTitle: '选择INNA的',
        reasonTitleTranslation: '四大理由',
        reasonDesc: '我们努力追求完美的质量，为客户开发和制造具有显著附加值的高科技产品',
        coreProductTitle: '核心产品',
        coreProductRequirement: '・精准匹配工业需求',
        coreProductDesc: '我们自己生产所有的核心部件，希望以此管理制造流程并控制生产质量',
        industryTitle: '覆盖各行各业的',
        industryRequirement: '完美的旋转',
        industryDesc: '从产品微型加工到重型机床切削，INNA 电主轴为不同领域提供可靠动力支持',
        newsTitle: '新闻',
        activityTitle: '与活动',
        newsDesc: '从产品微型加工到重型机床切削，INNA 电主轴为不同领域提供可靠动力支持',
        contactTitle: '联系',
        we: '我们',
        moreProduct: '更多产品',
        viewDetail: '查看详情',
        learnMore: '了解更多>>',
        submit: '发送',
        form: {
            companyName: '公司名称',
            industry: '所属行业',
            contactName: '联系人姓名',
            phoneNumber: '手机号码',
            workEmail: '工作邮箱',
            cooperationDemand: '合作需求',
            region: '地域',
            placeholder: {
                companyName: '请输入公司名称',
                industry: '请输入所属行业',
                contactName: '请输入联系人姓名',
                phoneNumber: '请输入手机号码',
                workEmail: '请输入工作邮箱',
                cooperationDemand: '请输入合作需求',
                region: '请选择地域',
            },
            message: {
                required: '请输入{field}',
                companyNameLength: '公司名称长度在 2 到 100 个字符之间',
                industryLength: '行业名称长度在 2 到 50 个字符之间',
                contactNameLength: '联系人姓名长度在 2 到 20 个字符之间',
                phoneNumberValid: '请输入有效的手机号码',
                emailValid: '请输入有效的邮箱地址',
                demandLength: '合作需求长度在 10 到 500 个字符之间'
            }
        },
        message: {
            submitSuccess: '提交成功！',
            submitError: '请填写正确的信息！'
        }
    },
    reasons: [
        {
            title: '高精度轴承技术',
            description1: '精密轴承技术',
            description2: '使用寿命提升300%'
        },
        {
            title: '高速稳定运行',
            description1: '最高转速90000转/分钟',
            description2: '温升≤15℃'
        },
        {
            title: '智能冷却系统',
            description1: '油水双循环冷却系统',
            description2: '24小时连续运行无过热风险'
        },
        {
            title: '定制化解决方案',
            description1: '针对航空航天、医疗、3C等行业',
            description2: '提供专属主轴解决方案'
        }
    ],items: {
        highPrecision: {
            title: '高精度轴承技术',
            desc1: '精密的轴承技术',
            desc2: '寿命提升300%'
        },
        highSpeed: {
            title: '高速稳定运转',
            desc1: '最高转速90,000rpm',
            desc2: '温升≤15℃'
        },
        coolingSystem: {
            title: '智能冷却系统',
            desc1: '油冷、水冷双循环系统',
            desc2: '24小时连续作业无过热风险'
        },
        customized: {
            title: '定制化解决方案',
            desc1: '针对航空、医疗、3C等行业',
            desc2: '提供专属主轴方案'
        }
    },orderTable:{
        orderList:{
            name:'订单列表',
            receivingInfo:'收件信息',
            note:'备注',
            createTime:'下单/支付时间',
            coupon:'优惠券',
            amountTo:'合计',
            orderNumber:'订单编号/操作',
            copySuccess:'复制成功！',
            totalQuantity:'总数',
            actualPayment:'实付'
        },
        emptyText: '暂无数据'
    },orderDetail:{
        receipt: '确认收货',
        pageTitle:'订单详情',
        invoice:'开票',
        viewInvoice:'查看发票',
        pendingPayment:'待付款',
        orderNumber:'订单编号',
        payNow:'立即付款',
        orderProgress:'订单进度',
        buyerOrder:'买家下单',
        buyerPayment:'买家付款',
        merchantShip:'商家发货',
        buyerReceive:'买家收货',
        orderInfo:'订单信息',
        orderNumberLabel:'订单编号:',
        orderTime:'下单时间:',
        userName:'用户名称:',
        userPhone:'用户手机:',
        paymentMethod:'支付方式:',
        wechatPay:'微信支付',
        paymentTime:'支付时间:',
        orderStatus:'订单状态:',
        receivingInfo:'收货信息',
        receiver:'收货人:',
        contactPhone:'联系电话:',
        receivingAddress:'收货地址:',
        detailAddress:'详细地址:',
        productInfo:'商品信息',
        productImage:'商品图片',
        productName:'商品名称',
        productCategory:'商品类别',
        addTime:'添加时间',
        operation:'操作',
        view:'查看',
        quantity:'数量',
        attribute:'属性',
        productTotalPrice:'商品总价:',
        payableAmount:'应付金额:',
        orderTotal:'订单总额:',
        logisticsInfo:'物流信息',
        noLogisticsInfo:'暂无物流信息，请先完成支付',
        viewTitle:'查看',
        cancel:'取 消',
        submit:'提 交',
        invoiceInfo:'发票信息',
        invoiceTitle:'发票',
        invoiceTitleType:'发票抬头类型',
        pleaseSelect:'请选择',
        personal:'个人',
        nonEnterprise:'非企业单位',
        enterprise:'企业单位',
        buyer:'购买方',
        buyerTaxNo:'购方税号',
        remark:'备注',
        invoiceDownload:'发票',
        invoiceLabel:'发票',
        close:'关 闭',
        backToList:'返回列表',
        orderStatusList:{
            pendingPayment:'待付款',
            pendingShip:'待发货',
            shipped:'已发货',
            completed:'已完成',
            closed:'已关闭'
        },
        messages:{
            noInvoiceRecord:'暂无发票记录，请等待',
            selectInvoiceTitleType:'请选择发票抬头类型',
            fillBuyerTaxNo:'请填写购方税号',
            fillBuyerName:'请填写购买方名称',
            submitSuccess:'提交成功',
            confirmDownload:'确定要下载这张发票吗？',
            downloadCancelled:'已取消下载',
            noOrderId: '无此订单',
            delivery: '收货成功',
        }
    },userInfo:{
        basicInfo:'基本信息',
        clickUpload:'点击上传',
        account:'账号',
        notSet:'未设置',
        gender:'性别',
        pleaseSelectGender:'请选择性别',
        birthday:'生日',
        securitySettings:'安全设置',
        bindPhone:'绑定手机',
        bindEmail:'绑定邮箱',
        addressInfo:'地址信息',
        countryRegion:'国家/地区',
        pleaseSelect:'请选择',
        province:'所在省市',
        city:'所在城市',
        saveInfo:'保存信息',
        receivingAddress:'收货地址',
        logout:'退出登录',
        bindPhoneTitle:'绑定手机',
        enterPhone:'请输入手机号',
        enterCode:'请输入验证码',
        getCode:'获取验证码',
        bindNow:'立即绑定',
        genderOption:{
            unknown:'未知',
            male:'男',
            female:'女'
        },
        messages:{
            uploadAvatarJPGOnly:'上传头像图片只能是 JPG 格式!',
            uploadAvatarSizeLimit:'上传头像图片大小不能超过 2MB!',
            saveSuccess:'保存成功',
            enterCorrectPhone:'请输入正确的手机号',
            phoneValidateFailed:'手机号校验失败',
            codeSent:'验证码已发送，请注意查收',
            codeSendFailed:'验证码发送失败',
            bindSuccess:'绑定成功',
            bindFailed:'绑定失败',
            bindFailedRetry:'绑定失败，请稍后重试',
            confirmLogout:'确定要退出登录吗？',
            confirm:'确定',
            cancel:'取消',
            logoutSuccess:'退出登录成功',
            logoutCancelled:'已取消退出'
        }
    },receivingAddress:{
        pageTitle:'收货地址',
        add:'新增',
        operation:'操作',
        edit:'编辑',
        delete:'删除',
        yes:'是',
        no:'否',
        addTitle:'添加收货地址',
        editTitle:'修改收货地址',
        receiver:'收货人',
        phone:'手机号码',
        area:'所在地区',
        detailAddress:'详细地址',
        postCode:'邮政编码',
        defaultAddress:'默认地址',
        enterReceiverName:'请输入收货人姓名',
        enterPhone:'请输入11位手机号码',
        selectArea:'请选择省/市/区',
        enterDetailAddress:'请输入街道、门牌号等详细信息',
        enterPostCode:'请输入邮政编码（选填）',
        confirm:'确 定',
        cancel:'取 消',
        tableColumns:{
            receiver:'收货人',
            phone:'电话/手机',
            area:'所在地区',
            detailAddress:'详细地址',
            postCode:'邮政编码',
            isDefault:'是否为默认'
        },
        messages:{
            confirmDelete:'是否确认删除收货地址的数据项？',
            deleteSuccess:'删除成功',
            editSuccess:'编辑成功',
            addSuccess:'新增成功',
            titleRequired:'标题不能为空'

        }
    },
    aboutUs: {
        title: "关于我们",
        companyIntro: {
            prompt: "公司介绍",
            title: "我们",
            titleHighlight: "是谁？"
        },
        techIntro: {
            prompt: "技术介绍",
            title: "我们",
            titleHighlight: "的能力"
        },
        serviceFields: {
            subtitle: "服务的主要领域",
            title: "覆盖各领域的",
            titleHighlight: "能力"
        }
    },
    shoppingMall: {
        buy: "立即购买",
    },
    waresDetails: {
        loading: "加载中...",
        thumbnailAlt: "产品缩略图",
        taxIncludedPrice: "含税价格",
        yuan: "元",
        sold: "已售",
        quantity: "数量",
        buyNow: "立刻购买",
        service: "联系客服",
        friendlyTip: "友情提示 ：",
        friendlyTipContent: "通过平台下单可以帮您减少交易过程中潜在的风险。让您资金安全、省心安心交易。",
        detail: "详情",
        productParameters: "产品参数"
    },
    payShopp: {
        sale: '您的销售工程师',
        receivingAddress: "收货地址",
        selectAddress: "选择地址",
        default: "默认",
        pleaseAddAddress: "请添加收货地址",
        productImage: "商品图片",
        productId: "商品编号: ",
        stock: "库存: ",
        selectSpec: "选择规格",
        selectedSpec: "已选规格:",
        purchaseQuantity: "购买数量",
        orderNote: "订单备注",
        notePlaceholder: "请输入备注信息（选填）",
        total: "合计:",
        brand: "品牌: ",
        unit: "单位: ",
        weight: "重量: ",
        Specifications: "规格: ",
        FriendlyReminder: "友情提示：",
        buyNow: "立即购买",
        messages: {
            pleaseAddAddress: "请添加收货地址",
            pleaseSelectCompleteSpec: "请选择完整规格",
            stockInsufficient: "该商品库存不足",
            createOrderFailed: "创建订单失败！",
            paySuccess: "支付成功！"
        }
    },
    serviceRepair: {
        localContact: "当地的金牌销售",
        localContactRepair: "当地的服务和维修人员联系方式",
        phone: "电话：",
        email: "邮箱：",
        repairRegistration: "主轴维修登记",
        supplementaryExplanation: "补充说明",
        supplementaryExplanationContent: "当您把主轴寄回INNA时，若可能，请使用原主轴运输箱，若不可能，建议以最佳最稳固的方式包装寄送主轴，INNA对主轴货物的丢失、被盗或损坏不承担责任。",
        send: "发送",
        messages: {
            sendSuccess: "发送成功！",
            pleaseEnter: "请输入",
            pleaseSelect: "请选择"
        }
    },
    product: {
        diameter: '直径',
        maximumSpeed: '最大转速',
        proInterface: '接口',
        bearingLubrication: '轴承润滑',
        proPower: '功率S1',
        proTorque: '扭矩S1',
        productList: '产品列表'
    },
    spindleEmpty: {
        title: '产品 ({count})',
        subtitle: '请选择主轴进行比较',
        description: '要查看主轴细节，请在性能图中进行选择。',
        tipMulti: '通过点击比较，您可以同时最多选择三个主轴',
        tipSingle: '点击单个圈，可选择单支主轴',
        tipFilter: '点击按钮，您可以通过参数进行筛选'
    },
    compare : '比较',
    cancel : '取消',
    details : '详情',
    detailView: '详细查看',
    pdfPreview: 'PDF预览',
    close: '关闭',
    CompareProductParameters: '比较产品参数',
    productCompared: {
        model: '型号',
        type: '类型',
        diameter: '直径(mm)',
        maximumSpeed: '最大转速(rev/min)',
        minimumSpeed: '最小转速(rev/min)',
        proInterface: '接口',
        bearingLubrication: '轴承润滑',
        proPower: '功率S1',
        proTorque: '扭矩S1',
        maxPowerS1: '最大功率S1 (kW)',
        minPowerS1: '最小功率S1 (kW)',
        maxTorqueS1: '最大扭矩S1 (Nm)',
        minTorqueS1: '最小扭矩S1 (Nm)'
    },
    TechnicalData: '技术数据',
    RatedData: '额定数据',
    back: '返回',
    message: {
        required: '请输入',
        select: '请选择',
        minLength: '长度不能少于2个字符',
        maxLength: '长度不能超过100个字符',
        validPhone: '请输入有效的手机号码',
        validEmail: '请输入有效的邮箱地址',
    },
    field: {
        companyName: '公司名称',
        industry: '所属行业',
        contactName: '联系人姓名',
        phoneNumber: '手机号码',
        workEmail: '工作邮箱',
        cooperationDemand: '合作需求',
        region: '地域',
    },
    upload: '下载',
    walksLife: {
        relatedImages: '下载'
    },
    loading: '加载中...',
    login: {
        expiredMessage: '您的登录已过期或未登录，请重新登录',
        expiredTitle: '登录过期'
    },
};
